import "./ContactUs.css";
import { useState, useEffect } from "react";
import { firestore } from "../Firebase";
import { collection, addDoc } from "firebase/firestore";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false); // State for modal visibility
  const contactsCollectionRef = collection(firestore, "contactDetails");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(contactsCollectionRef, {
        name,
        email,
        phone,
        message,
        file: file ? file.name : "No file",
      });
      setShowModal(true); // Show modal on successful submission
      // Reset form fields
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
      setFile(null);
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const closeModal = () => {
    setShowModal(false); // Close modal
  };

  // Disable scrolling when modal is open
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showModal]);

  return (
    <>
      <div id="contactus" className="contact-us-section">
        <div className="container">
          <div className="row align-items-center" style={{minHeight: "90vh"}}>
            <div className="col-md-8 col-12 mb-5">
              <div className="text-white title-text">Contact Us</div>
              <div className="subtitle-text">
                <span className="text-yellow">Click Here</span>{" "}
                <span className="text-white">to visit our location</span>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <div className="contact-form-container">
                <h2 className="form-heading">Contact Form</h2>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 form-group-custom">
                    <label
                      htmlFor="name"
                      className="form-label visually-hidden"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control form-control-custom"
                      id="name"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3 form-group-custom">
                    <label
                      htmlFor="email"
                      className="form-label visually-hidden"
                    >
                      E-mail
                    </label>
                    <input
                      type="email"
                      autoComplete="off"
                      className="form-control form-control-custom"
                      id="email"
                      placeholder="E-mail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3 form-group-custom">
                    <label
                      htmlFor="phone"
                      className="form-label visually-hidden"
                    >
                      Phone
                    </label>
                    <input
                      type="tel"
                      autoComplete="off"
                      className="form-control form-control-custom"
                      id="phone"
                      placeholder="Phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>

                  <div className="mb-3 form-group-custom">
                    <label
                      htmlFor="message"
                      className="form-label visually-hidden"
                    >
                      Message
                    </label>
                    <textarea
                      className="form-control form-control-custom"
                      id="message"
                      autoComplete="off"
                      rows="3"
                      placeholder="Message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="d-flex align-items-center justify-content-between flex-wrap file-upload-section">
                    <label htmlFor="fileUpload" className="upload-file-label">
                      <i className="bi bi-cloud-arrow-up-fill"></i>Upload File
                      <input
                        type="file"
                        id="fileUpload"
                        className="d-none"
                        onChange={handleFileChange}
                      />
                    </label>
                    {file && (
                      <span className="file-upload-name">{file.name}</span>
                    )}

                    <button
                      type="submit"
                      className="btn btn-send-message mt-3 mt-md-0"
                    >
                      Send Message <i className="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <>
          {/* Modal Backdrop */}
          <div className="modal-backdrop fade show"></div>

          {/* Bootstrap Modal */}
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Successful!</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  Thank you for reaching out! We will get back to you soon.
                  <p className="mt-3">
                    If you have any further questions, feel free to contact us
                    at{" "}
                    <a href="mailto:contact @anushthanidealabs@gmail.com">
                      anushthanidealabs@gmail.com
                    </a>
                    .
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-send-message"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ContactUs;
